<template>
  <div id="app" class="outer">
    <header class="header">
      <div class="bottom">
        <h1 class="logoArea">
          <a class="logo" title="logo" @click="$router.push('/')" target="_blank">
            Shop
          </a>
          <!-- <img src="./assets/images/logo.jpg" @click="$router.push('/')" style="width: 50px;border-radius: 50%;display: block;" alt=""> -->
        </h1>
        <div class="searchArea">
          <form class="searchForm">
            <el-input type="text" v-model="inputSearch" @change="searchName" placeholder="Search…" id="autocomplete"
              class="input-error input-xxlarge">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </form>
        </div>
        <div @click="opneTabDialog" class="pointer blueBold iswebapp">
          <i class="el-icon-s-operation tab-icon-pr" style="font-size:24px;display:block;"></i>
        </div>
        <div @click="$router.push('/shopping')" class="pointer hoverBlueBold pl12" style="position: relative;">
          <i class="iconfont icon-gouwuche"></i>
          <div v-if="cartListNum" class="num">{{ cartListNum }}</div>
        </div>
      </div>
      <div class="outerCon">
        <el-menu class="el-menu-demo" :default-active="activeMenu" mode="horizontal" @select="handleSelect">
          <el-menu-item class="firstCon" index="1" @click="$router.push('/')">
            <svg viewBox="0 0 17 17" style="width: 18px; height: 18px; margin: auto 4px;">
              <path
                d="M11.044 5.588c6.307.633 6.326.672 1.577 5.064 1.375 6.405 1.283 6.482-4.126 3.126-5.408 3.356-5.482 3.28-4.107-3.126-4.767-4.392-4.73-4.43 1.559-5.064 2.548-6.117 2.567-6.117 5.097 0z"
                stroke="#C0952B" fill="#FFD560" fill-rule="evenodd"></path>
            </svg>
            Home
          </el-menu-item>
          <el-menu-item class="firstCon" index="2" @click="gotoType('Phones')">
            Phones
          </el-menu-item>
          <el-menu-item class="firstCon" index="3" @click="gotoType('Appliances')">
            Appliances
          </el-menu-item>
          <el-menu-item class="firstCon" index="4" @click="$router.push('/foot/about')">
            About
          </el-menu-item>
          <el-menu-item class="firstCon" index="5" @click="$router.push('/foot/termsofUse')">
            Terms and Conditions
          </el-menu-item>
          <!-- <el-menu-item class="firstCon" index="4" @click="gotoType('phones')">
            Mobile Accessories
          </el-menu-item>
          <el-menu-item class="firstCon" index="5" @click="gotoType('Sunglasses')">
            Sunglasses
          </el-menu-item>
          <el-submenu index="5">
            <template slot="title">Bags</template>
            <el-menu-item @click="gotoType('Bags')" index="6-1">Men's Bags</el-menu-item>
            <el-menu-item @click="gotoType('Bags')" index="6-2">Women's Bags</el-menu-item>
          </el-submenu> -->
          <!-- <el-menu-item index="6">More</el-menu-item> -->
        </el-menu>
      </div>
    </header>

    <router-view v-if="isRefresh" class="con"></router-view>


    <div class="footer">
      <div class="footer-container">
        <div class="footerList">
          <el-row>
            <el-col :xs="24" :sm="8" class="bottom-footer-pa">
              <div class="foottitle">ABOUT US</div>
              <div class="is-divider"></div>
              <div class="pointer" @click="$router.push('/foot/about')">About Us</div>
              <div class="pointer" @click="$router.push('/foot/contact')">Contact Us</div>
              <div class="pointer" @click="$router.push('/shopping')">Card</div>
            </el-col>
            <el-col :xs="24" :sm="8" class="bottom-footer-pa">
              <div class="foottitle">SERVICE</div>
              <div class="is-divider"></div>
              <div class="pointer" @click="$router.push('/foot/refundPolicy')">Refund Policy</div>
              <div class="pointer" @click="$router.push('/foot/termsofUse')">Terms of Use</div>
              <div class="pointer" @click="$router.push('/foot/privacyPolicy')">Privacy Policy</div>
            </el-col>
            <el-col :xs="24" :sm="8">
              <div class="foottitle">WISDOM SHENG LIMITED</div>
              <div class="is-divider"></div>
              <!-- <div>Phone: +971554121820</div> -->
              <div>E-mail: information@zhiheshengmall.com</div>
              <div>Address: RM03, 24/F, HO KING COMM CTR,2-16 FAYUEN ST, MONG KOK HONG KONG</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      <img src="./assets/images/home/pingpai.png" alt="">
    </div>
    <div class="copyright">Copyright 2024 shop, All rights reserved.</div>

    <TabDialog ref="TabDialogRef" @refresh="refresh" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import './style/home.css';
import TabDialog from './views/tabDialog.vue'
export default {
  name: 'App',
  components: { TabDialog },
  computed: {
    ...mapState({
      cartListNum: state => state.user.cartListNum,
    })
  },
  data() {
    return {
      isRefresh: true,
      activeMenu: '1',
      inputSearch: ''
    }
  },
  methods: {
    searchName () {
      this.$router.push({
        path: '/cats',
        query: {
          type: this.inputSearch,
          types: 'search'
        }
      })
      this.refresh()
    },
    refresh() {
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    handleSelect(val, val1, val2) {
      // console.log(val);
      localStorage.setItem('menu',val)
      let num = val.slice(0, 1)
      if (num == 2) {
        this.gotoType('Coat')
      } else if (num == 3) {
        this.gotoType('T-shirt')
      }
      this.refresh()
    },
    gotoType(val) {
      this.$router.push({
        path: '/cats',
        query: {
          type: val
        }
      })
      this.refresh()
    },
    opneTabDialog() {
      this.$refs.TabDialogRef.show()
    }
  },
  mounted() {
    if (localStorage.getItem('menu')) {
      let menu =localStorage.getItem('menu')
      this.activeMenu = menu
    }
  }
}
</script>

<style scoped>
.num {
  width: 14px;
  height: 14px;
  font-size: 12px;
  color: #ffffff;
  background-color: rgb(16, 119, 76);
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 20px;
  text-align: center;
  line-height: 14px;
}

.footerItemCon li {
  cursor: pointer;
}

.con {
  min-height: calc(100vh - 110px - 300px);
}

::v-deep.el-input__icon {
  color: #000;
  font-size: 19px;
  margin-right: 8px;
}

.icon-yonghu,
.icon-gouwuche {
  font-size: 24px !important;
}

.outerCon {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 8px;
}

@media (max-width: 768px) {
  .outerCon {
    display: none;
  }
}

::v-deep.el-menu.el-menu--horizontal {
  border: none;
}

.buleborder {
  border-bottom: 2px solid rgb(47, 183, 236);
}

::v-deep.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  outline: 0;
  color: #1e73be;
  border-bottom: 2px solid #1e73be !important;
}

::v-deep.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid #1e73be;
}

.firstCon:first-child.el-menu-item {
  padding-left: 0
}

::v-deep.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  border-bottom: 2px solid #1e73be !important;
  color: #1e73be
}

::v-deep.el-menu--horizontal>.el-submenu .el-submenu__title {
  color: rgb(14, 22, 28);
  font-size: 16px;
}

.searchArea ::v-deep input::placeholder {
  color: #3f5663 !important;
  font-size: 16px
}
.pointer:hover {
  color: rgb(238, 109, 4);
}
</style>
